import { useRef, useState, useCallback } from "react";
import { formatTypeLabel, sanitizeInput, showToast } from "../utils/utils";
import {
  HTTP_STATUS_SUCCESS,
  showToastType
} from "../utils/constants/appConstants";
import { getReportingUpdateSalesChecklistCommentUrl } from "../utils/constants/apiEndPoints";
import privateAxios from "../utils/axiosPrivate";
import { ownerTab } from "../locales/en";

export const useSalesChecklistComment = ({ userId }) => {
  const [commentData, setCommentData] = useState({});
  const originalNotesRef = useRef({});

  const updateSalesData = useCallback(
    async (rowId, value, sectionEnum) => {
      const currentValue = sanitizeInput(value || "");
      const originalValue = sanitizeInput(
        originalNotesRef.current[rowId] || ""
      );

      if (currentValue === originalValue) return;

      try {
        const response = await privateAxios.post(
          getReportingUpdateSalesChecklistCommentUrl(userId),
          {
            section: sectionEnum,
            note: currentValue
          }
        );

        if (response?.data?.status === HTTP_STATUS_SUCCESS) {
          showToast(
            `${formatTypeLabel(sectionEnum)} ${
              response?.data?.message || ownerTab?.directorsOwner?.errMsg?.item1
            }`,
            showToastType.success
          );

          originalNotesRef.current[rowId] = currentValue;
        }
      } catch (error) {
        showToast(error?.response?.data?.message, showToastType.error);
      }
    },
    [userId]
  );

  return {
    commentData,
    setCommentData,
    originalNotesRef,
    updateSalesData
  };
};
